export function isBlankCustomerLicenseForm(values) {
    return Object.values(values).every((value) => value.trim() === '');
}
//# sourceMappingURL=is-blank-customer-license-form.js.map